import { formatCurrency } from "../../services/formatters";
import { formatItemYear } from "../../services/formatItemYear";

const variantLabel = (variant) =>
  typeof variant === "string" ? variant : variant?.name || "";

export const itemListColumns = [
  { key: "year", label: "Year", render: (card) => formatItemYear(card.year, card.year_end) },
  { key: "brand", label: "Brand" },
  { key: "set_name", label: "Set" },
  { key: "subset", label: "Subset / Insert" },
  { key: "name", label: "Name" },

  {
    key: "variants",
    label: "Variants",
    render: (card) => {
      const variantsList = Array.isArray(card.variants)
        ? card.variants.map(variantLabel).filter(Boolean)
        : typeof card.variants === "string"
          ? card.variants
              .split(",")
              .map((value) => value.trim())
              .filter(Boolean)
          : [];

      return variantsList.join(", ");
    },
  },

  {
    key: "grading_company",
    label: "Grading Co",
  },

  { key: "grade", label: "Grade" },
  { key: "cert_number", label: "Cert #" },
  { key: "card_number", label: "Card #" },

  {
    key: "type",
    label: "Type",
    render: (item) => item.subcategory ?? "Unknown",
  },

  {
    key: "estimated_value",
    label: "Est. Value - Work in Progress",
    render: (item) => {
      const val = item.estimated_value;

      if (
        val === null ||
        val === undefined ||
        val === "" ||
        Number.isNaN(Number(val))
      ) {
        return "TBD";
      }

      return formatCurrency(Number(val));
    },
  },
];
